import React from "react";
import "./Card.css";

const Card = ({ title, value, png: Icon, color }) => {
  return (
    <div
      className="card shadow-sm"
      style={{
        background: color?.backGround || "#fff",
        boxShadow: color?.boxShadow || "0px 5px 15px rgba(0,0,0,0.1)",
        borderRadius: "1rem",
        color: "#fff",
      }}
    >
      <div className="card-body d-flex flex-column justify-content-center align-items-center">
        {Icon && <Icon size={30} className="mb-2" />}
        <h6 className="card-title">{title}</h6>
        <h3 className="card-value mt-2">{value}</h3>
      </div>
    </div>
  );
};

export default Card;
